import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-father',
  templateUrl: './father.component.html',
  styleUrls: ['./father.component.scss']
})
export class FatherEligibilityComponent implements OnInit {

	deceased = this.appState.get();
	all_conditions: boolean = false;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	
	// Eligibility Check
	eligibilityCheck(deceased: any = false) {
		if( deceased ) {
			this.deceased = deceased;
		}

		// Father Eligibility
	    if( this.deceased['father'].alive == "true" ) {
	      var this_father = this.deceased['father'];

	      // If All empty Continue without Checking
	      if( this_father.muslim == "" && this_father.legitimate == "" && this_father.deceased_killer == "" && (this_father.disowned == "true" || this_father.disowned == "") && (this_father.free_person == "true" || this_father.free_person == "") ) {
	        
	        this.deceased['father'].eligibility = "";
	      		return undefined;
	      
	      } else {

	        // Otherwise Check
	        if( this_father.muslim == "true" && this_father.legitimate == "true" && this_father.deceased_killer == "true" && this_father.disowned == "true" && this_father.free_person == "true" ) {
	          
	          this.deceased['father'].eligibility = "true";
	          this.all_conditions = true;
	        
	        } else {
	          
	          this.deceased['father'].eligibility = "false";
	          if( this.all_conditions == false )  {
	            this.all_conditions = false;
	          }
	        }
	      }

	      return this.all_conditions;
	    }
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {
		// Eligibility Test
		this.eligibilityCheck();

		// Save
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

	ngOnInit() {

	}

}
